var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 41,
    viewBox: "0 0 142 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.741 40.9885H5.25926C2.36798 40.9885 0 38.7373 0 35.9885V5.98853C0 3.23978 2.36798 0.988529 5.25926 0.988529H136.741C139.632 0.988529 142 3.23978 142 5.98853V35.9885C142 38.7373 139.632 40.9885 136.741 40.9885Z",
    fill: "#0B0D0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.741 1.78978C139.176 1.78978 141.157 3.67353 141.157 5.98853V35.9885C141.157 38.3035 139.176 40.1873 136.741 40.1873H5.25926C2.82422 40.1873 0.842796 38.3035 0.842796 35.9885V5.98853C0.842796 3.67353 2.82422 1.78978 5.25926 1.78978H136.741ZM136.741 0.988529H5.25926C2.36798 0.988529 0 3.23978 0 5.98853V35.9885C0 38.7373 2.36798 40.9885 5.25926 40.9885H136.741C139.632 40.9885 142 38.7373 142 35.9885V5.98853C142 3.23978 139.632 0.988529 136.741 0.988529Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9764 8.52721C10.6674 8.83471 10.4886 9.31346 10.4886 9.93346V32.0485C10.4886 32.6685 10.6674 33.1472 10.9764 33.4547L11.0527 33.5222L24.0877 21.1347V20.8422L11.0527 8.45472L10.9764 8.52721Z",
    fill: "url(#paint0_linear_2536_8395)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.428 25.266L24.0878 21.1347V20.8422L28.4333 16.711L28.5306 16.7647L33.6767 19.5485C35.1454 20.3385 35.1454 21.6385 33.6767 22.4335L28.5306 25.2122L28.428 25.266Z",
    fill: "url(#paint1_linear_2536_8395)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5304 25.2123L24.0876 20.9885L10.9763 33.4547C11.4641 33.9422 12.2595 34.001 13.1641 33.5135L28.5304 25.2123Z",
    fill: "url(#paint2_linear_2536_8395)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5304 16.7649L13.1641 8.46365C12.2595 7.98115 11.4641 8.0399 10.9763 8.5274L24.0876 20.9886L28.5304 16.7649Z",
    fill: "url(#paint3_linear_2536_8395)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8762 11.2321C49.8762 12.0671 49.6132 12.7359 49.0952 13.2346C48.4995 13.8259 47.7238 14.1234 46.7732 14.1234C45.8647 14.1234 45.0889 13.8209 44.4525 13.2246C43.8149 12.6196 43.4967 11.8771 43.4967 10.9884C43.4967 10.0996 43.8149 9.35714 44.4525 8.75714C45.0889 8.15589 45.8647 7.85339 46.7732 7.85339C47.2255 7.85339 47.6567 7.94214 48.0683 8.10714C48.4785 8.27339 48.8125 8.49839 49.0544 8.77589L48.5048 9.30339C48.0827 8.82964 47.5082 8.59589 46.7732 8.59589C46.1105 8.59589 45.536 8.81589 45.0482 9.25964C44.5656 9.70464 44.3237 10.2809 44.3237 10.9884C44.3237 11.6959 44.5656 12.2771 45.0482 12.7221C45.536 13.1609 46.1105 13.3859 46.7732 13.3859C47.4766 13.3859 48.0683 13.1609 48.535 12.7171C48.8427 12.4234 49.0176 12.0184 49.0636 11.5009H46.7732V10.7784H49.8288C49.8656 10.9346 49.8762 11.0859 49.8762 11.2321Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.724 8.72715H51.8538V10.6272H54.4413V11.3497H51.8538V13.2497H54.724V13.9859H51.0412V7.99091H54.724V8.72715Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.145 13.9859H57.3325V8.72715H55.5719V7.99091H59.9069V8.72715H58.145V13.9859Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.044 13.9859V7.99091H63.8552V13.9859H63.044Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4512 13.9859H66.6452V8.72715H64.8781V7.99091H69.2183V8.72715H67.4512V13.9859Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4254 13.2146C76.8035 13.8209 76.033 14.1234 75.114 14.1234C74.1897 14.1234 73.4192 13.8209 72.7973 13.2146C72.1767 12.6096 71.8677 11.8671 71.8677 10.9884C71.8677 10.1096 72.1767 9.36714 72.7973 8.76214C73.4192 8.15589 74.1897 7.85339 75.114 7.85339C76.0278 7.85339 76.7983 8.15589 77.4202 8.76714C78.046 9.37714 78.355 10.1146 78.355 10.9884C78.355 11.8671 78.046 12.6096 77.4254 13.2146ZM73.3982 12.7121C73.8662 13.1609 74.4355 13.3859 75.114 13.3859C75.7872 13.3859 76.3617 13.1609 76.8246 12.7121C77.2913 12.2634 77.528 11.6871 77.528 10.9884C77.528 10.2896 77.2913 9.71339 76.8246 9.26464C76.3617 8.81589 75.7872 8.59089 75.114 8.59089C74.4355 8.59089 73.8662 8.81589 73.3982 9.26464C72.9314 9.71339 72.6947 10.2896 72.6947 10.9884C72.6947 11.6871 72.9314 12.2634 73.3982 12.7121Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4948 13.9859V7.99091H80.481L83.5471 12.6534H83.5826L83.5471 11.5009V7.99091H84.3583V13.9859H83.5116L80.3008 9.09341H80.2653L80.3008 10.2509V13.9859H79.4948Z",
    fill: "#FDFFFD",
    stroke: "black",
    strokeWidth: 0.122453,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6679 22.7411C69.1973 22.7411 67.1791 24.5286 67.1791 26.9949C67.1791 29.4411 69.1973 31.2474 71.6679 31.2474C74.1437 31.2474 76.1619 29.4411 76.1619 26.9949C76.1619 24.5286 74.1437 22.7411 71.6679 22.7411ZM71.6679 29.5724C70.3123 29.5724 69.1461 28.5086 69.1461 26.9949C69.1461 25.4611 70.3123 24.4161 71.6679 24.4161C73.0235 24.4161 74.195 25.4611 74.195 26.9949C74.195 28.5086 73.0235 29.5724 71.6679 29.5724ZM61.8738 22.7411C59.398 22.7411 57.3851 24.5286 57.3851 26.9949C57.3851 29.4411 59.398 31.2474 61.8738 31.2474C64.3483 31.2474 66.3626 29.4411 66.3626 26.9949C66.3626 24.5286 64.3483 22.7411 61.8738 22.7411ZM61.8738 29.5724C60.5169 29.5724 59.3468 28.5086 59.3468 26.9949C59.3468 25.4611 60.5169 24.4161 61.8738 24.4161C63.2294 24.4161 64.3956 25.4611 64.3956 26.9949C64.3956 28.5086 63.2294 29.5724 61.8738 29.5724ZM50.2193 24.0449V25.8524H54.7594C54.6266 26.8624 54.2716 27.6049 53.7272 28.1224C53.0646 28.7474 52.0324 29.4411 50.2193 29.4411C47.4253 29.4411 45.2375 27.2974 45.2375 24.6411C45.2375 21.9849 47.4253 19.8411 50.2193 19.8411C51.73 19.8411 52.8292 20.4024 53.6405 21.1299L54.9803 19.8561C53.8456 18.8261 52.3362 18.0349 50.2193 18.0349C46.3879 18.0349 43.168 20.9986 43.168 24.6411C43.168 28.2836 46.3879 31.2474 50.2193 31.2474C52.2901 31.2474 53.8456 30.6024 55.0684 29.3924C56.3214 28.2011 56.7119 26.5261 56.7119 25.1736C56.7119 24.7536 56.6751 24.3674 56.6093 24.0449H50.2193ZM97.8761 25.4461C97.5066 24.4949 96.3667 22.7411 94.0447 22.7411C91.7438 22.7411 89.8281 24.4649 89.8281 26.9949C89.8281 29.3774 91.7241 31.2474 94.2656 31.2474C96.3207 31.2474 97.5066 30.0561 97.9944 29.3624L96.4692 28.3961C95.9604 29.1036 95.2675 29.5724 94.2656 29.5724C93.2703 29.5724 92.5563 29.1386 92.0988 28.2836L98.0825 25.9299L97.8761 25.4461ZM91.7753 26.8624C91.7241 25.2224 93.1151 24.3824 94.1118 24.3824C94.8928 24.3824 95.5554 24.7536 95.7763 25.2849L91.7753 26.8624ZM86.9118 30.9886H88.8788V18.4886H86.9118V30.9886ZM83.6905 23.6886H83.6248C83.183 23.1911 82.3402 22.7411 81.2726 22.7411C79.0322 22.7411 76.9837 24.6111 76.9837 27.0086C76.9837 29.3924 79.0322 31.2474 81.2726 31.2474C82.3402 31.2474 83.183 30.7936 83.6248 30.2811H83.6905V30.8911C83.6905 32.5174 82.7768 33.3911 81.3028 33.3911C80.1011 33.3911 79.3556 32.5661 79.0479 31.8724L77.3374 32.5511C77.8304 33.6786 79.136 35.0661 81.3028 35.0661C83.609 35.0661 85.555 33.7761 85.555 30.6374V22.9999H83.6905V23.6886ZM81.4409 29.5724C80.0853 29.5724 78.9506 28.4936 78.9506 27.0086C78.9506 25.5099 80.0853 24.4161 81.4409 24.4161C82.7768 24.4161 83.8299 25.5099 83.8299 27.0086C83.8299 28.4936 82.7768 29.5724 81.4409 29.5724ZM107.085 18.4886H102.381V30.9886H104.342V26.2524H107.085C109.264 26.2524 111.4 24.7536 111.4 22.3699C111.4 19.9874 109.258 18.4886 107.085 18.4886ZM107.136 24.5136H104.342V20.2274H107.136C108.601 20.2274 109.437 21.3836 109.437 22.3699C109.437 23.3374 108.601 24.5136 107.136 24.5136ZM119.263 22.7174C117.845 22.7174 116.372 23.3124 115.765 24.6311L117.506 25.3249C117.881 24.6311 118.57 24.4061 119.298 24.4061C120.316 24.4061 121.348 24.9874 121.364 26.0136V26.1449C121.009 25.9499 120.249 25.6611 119.314 25.6611C117.439 25.6611 115.529 26.6424 115.529 28.4736C115.529 30.1486 117.064 31.2274 118.791 31.2274C120.111 31.2274 120.839 30.6611 121.297 30.0024H121.364V30.9686H123.259V26.1736C123.259 23.9574 121.518 22.7174 119.263 22.7174ZM119.026 29.5674C118.385 29.5674 117.49 29.2649 117.49 28.5086C117.49 27.5411 118.605 27.1699 119.571 27.1699C120.434 27.1699 120.839 27.3511 121.364 27.5899C121.21 28.7474 120.162 29.5674 119.026 29.5674ZM130.161 22.9911L127.906 28.4099H127.839L125.508 22.9911H123.393L126.895 30.5636L124.897 34.7774H126.947L132.344 22.9911H130.161ZM112.478 30.9886H114.445V18.4886H112.478V30.9886Z",
    fill: "#FDFFFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2536_8395",
    x1: 22.9304,
    y1: 32.2788,
    x2: 6.16941,
    y2: 14.6487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2536_8395",
    x1: 35.5892,
    y1: 20.9871,
    x2: 10.1376,
    y2: 20.9871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2536_8395",
    x1: 26.1145,
    y1: 18.6924,
    x2: 3.38529,
    y2: -5.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2536_8395",
    x1: 7.67589,
    y1: 40.8125,
    x2: 17.8255,
    y2: 30.1366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google Play.87b1233a4f9b22aded8fb2f328f0d70a.svg";
export { ForwardRef as ReactComponent };